import { showErrorToast, showToast } from '~/utils/toast-notifications';
import { HOME_FEED_TAB_KEYS } from '~/utils/home-feed-tab-keys';
import { eventManager } from '@/utils/behavior/applicationEvents/event-manager';

export default {
  setActiveFeedTab(context, payload) {
    context.commit('SET_ACTIVE_FEED_TAB', payload);
  },
  getHomeForYouFeed(context, payload) {
    const { noSkeletons } = payload ?? {};

    if (!noSkeletons) context.commit('GET_FEED_START');

    return this.dispatch('api/getHomeForYouFeed')
      .then((res) => {
        context.commit('GET_FEED_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('GET_FEED_ERROR', err);
      });
  },
  incrementReplyCount(context, payload) {
    if (payload && payload.postId) {
      context.commit('INCREMENT_POST_REPLY_COUNT', payload.postId);
    }
  },
  likePost(context, payload) {
    context.commit('UPDATE_POST_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.postId)
      .then((res) => {
        context.commit('UPDATE_POST_LIKE', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_POST_LIKE', payload);
        context.commit('SET_ERROR', err);
      });
  },
  favoritePost(context, payload) {
    this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_POST_FAVORITE', res.data);
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  countNewPost(context) {
    this.$api.getFeed().then((res) => {
      context.commit('COUNT_NEW_POST_SUCCESS', res.data);
    });
  },
  getNextPosts(context) {
    context.commit('SET_NEXT_POSTS_LOADING', true);

    const cursor = context.getters.homeForYouFeedCursor;

    return this.dispatch('api/getHomeForYouFeed', { pagination: cursor })
      .then((res) => {
        context.commit('APPEND_POSTS_TO_FEED', {
          ...res.data,
          feedTab: HOME_FEED_TAB_KEYS.FOR_YOU,
        });
        return res;
      })
      .catch((err) => {
        context.commit('GET_FEED_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_NEXT_POSTS_LOADING', false);
      });
  },
  appendNewPostAtTop(context, post) {
    context.commit('APPEND_NEW_POST_AT_TOP', post);
  },
  updatePostAfterEdit(context, post) {
    showToast(window.$nuxt.$t('post_updated_ok'));
    context.commit('UPDATE_POST_AFTER_EDIT', post);
  },
  /// Replies
  postComment(context, payload) {
    return this.dispatch('api/createPost', payload)
      .then((res) => {
        showToast(window.$nuxt.$t('post_created_ok'));
        context.commit('APPEND_NEW_REPLY', res.data);
        eventManager.raiseCreateCommentEvent({
          event_category: 'Interaction article',
          event_action: 'Comment an article',
          post_name: '',
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.dir(err);
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.target,
        });
      });
  },
  updateReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_REPLY_AFTER_EDIT', {
          postId: payload.postId,
          data: res.data,
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.target,
        });
      });
  },
  updateNestedReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_NESTED_REPLY_AFTER_EDIT', {
          postId: payload.postId,
          replyId: payload.replyId,
          nestedReplyId: payload.nestedReplyId,
          data: res.data,
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.data.target,
        });
      });
  },
  likeReply(context, payload) {
    context.commit('UPDATE_REPLY_LIKE_OPTIMISTIC', payload);
    return this.dispatch('api/likePost', payload.replyId)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_REPLY_LIKE', payload);
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.replyId,
        });
      });
  },
  favoriteReply(context, payload) {
    return this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  incrementReplyReplyCount(context, payload) {
    if (payload && payload.postId) {
      context.commit('INCREMENT_REPLY_REPLY_COUNT', payload);
    }
  },
  /// Nested Replies
  loadNestedReplies(context, payload) {
    return this.dispatch('api/getPostReplies', {
      postId: payload.replyId,
      params: payload.params,
    })
      .then((res) => {
        context.commit('SET_NESTED_REPLIES', {
          replies: res.data,
          postId: payload.postId,
          replyId: payload.replyId,
        });
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  loadNextNestedReplies(context, payload) {
    return this.dispatch('api/getPostReplies', {
      postId: payload.replyId,
      params: payload.params,
    })
      .then((res) => {
        context.commit('APPEND_NESTED_REPLY_BOTTOM', {
          replies: res.data,
          postId: payload.postId,
          replyId: payload.replyId,
        });
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  appendNestedReplyTop(context, payload) {
    context.commit('APPEND_NESTED_REPLY_TOP', payload);
  },
  favoriteNestedReply(context, payload) {
    return this.dispatch('api/favoritePost', payload.nestedReplyId)
      .then((res) => {
        context.commit('UPDATE_NESTED_REPLY', {
          data: res.data,
          postId: payload.postId,
        });
      })
      .catch((err) => {
        context.commit('SET_ERROR', err);
      });
  },
  likeNestedReply(context, payload) {
    context.commit('UPDATE_NESTED_REPLY_LIKE_OPTIMISTIC', payload);
    return this.dispatch('api/likePost', payload.nestedReplyId)
      .then((res) => {
        context.commit('UPDATE_NESTED_REPLY', {
          data: res.data,
          postId: payload.postId,
        });
      })
      .catch((err) => {
        context.commit('ROLLBACK_NESTED_REPLY_LIKE', payload);
        context.commit('SET_REPLIES_ERROR', {
          err: err,
          postId: payload.replyId,
        });
      });
  },
  incrementNestedReplyReplyCount(context, payload) {
    context.commit('INCREMENT_NESTED_REPLY_REPLY_COUNT', payload);
  },
  closeFeedWelcomeCard(context, profileId) {
    return this.dispatch('api/updateProfile', {
      profileId: profileId,
      data: { hasSeenFeedWelcomeCard: true },
    }).then((res) => {
      if (res.data.hasSeenFeedWelcomeCard) {
        this.dispatch('authentication/closeFeedWelcomeCard');
      }
    });
  },
  deleteUserPost(context, payload) {
    return this.dispatch('api/deleteUserPost', payload)
      .then((res) => {
        context.commit('DELETE_USER_POST_SUCCESS', res.data);
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_USER_POST_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  deletePostReply(context, payload) {
    return this.dispatch('api/deleteUserPost', { postId: payload.replyId })
      .then((res) => {
        context.commit('DELETE_POST_REPLY_SUCCESS', {
          postId: payload.postId,
          replyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  deletePostNestedReply(context, payload) {
    return this.dispatch('api/deleteUserPost', {
      postId: payload.nestedReplyId,
    })
      .then((res) => {
        context.commit('DELETE_POST_NESTED_REPLY_SUCCESS', {
          postId: payload.postId,
          replyId: payload.replyId,
          nestedReplyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_NESTED_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },

  // News feed
  getHomeNewsFeed(context, payload) {
    const { noSkeletons } = payload ?? {};

    if (!noSkeletons) context.commit('GET_NEWS_FEED_START');

    return this.dispatch('api/getHomeNewsFeed')
      .then((res) => {
        context.commit('GET_NEWS_FEED_SUCCESS', res.data);
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },

  getNextNewsPosts(context) {
    context.commit('SET_NEXT_NEWS_POSTS_LOADING', true);

    const cursor = context.getters.homeNewsFeedCursor;

    return this.dispatch('api/getHomeNewsFeed', { pagination: cursor })
      .then((res) => {
        context.commit('APPEND_POSTS_TO_FEED', {
          ...res.data,
          feedTab: HOME_FEED_TAB_KEYS.NEWS,
        });
        return res;
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      })
      .finally(() => {
        context.commit('SET_NEXT_NEWS_POSTS_LOADING', false);
      });
  },

  // Replies
  postNewsComment(context, payload) {
    return this.dispatch('api/createPost', payload)
      .then((res) => {
        showToast(window.$nuxt.$t('post_created_ok'));
        context.commit('APPEND_NEW_NEWS_REPLY', res.data);
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        console.dir(err);
        context.commit('SET_NEWS_REPLIES_ERROR', {
          err: err,
          postId: payload.target,
        });
      });
  },

  incrementNewsReplyReplyCount(context, payload) {
    if (payload && payload.postId) {
      context.commit('INCREMENT_NEWS_REPLY_REPLY_COUNT', payload);
    }
  },

  likeNewsReply(context, payload) {
    context.commit('UPDATE_NEWS_REPLY_LIKE_OPTIMISTIC', payload);
    return this.dispatch('api/likePost', payload.replyId)
      .then((res) => {
        context.commit('UPDATE_NEWS_REPLY', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_NEWS_REPLY_LIKE', payload);
        context.commit('SET_NEWS_REPLIES_ERROR', {
          err: err,
          postId: payload.replyId,
        });
      });
  },

  likeNewsPost(context, payload) {
    context.commit('UPDATE_NEWS_POST_LIKE_OPTIMISTIC', payload);
    this.dispatch('api/likePost', payload.postId)
      .then((res) => {
        context.commit('UPDATE_NEWS_POST_LIKE', res.data);
      })
      .catch((err) => {
        context.commit('ROLLBACK_NEWS_POST_LIKE', payload);
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },

  favoriteNewsPost(context, payload) {
    this.dispatch('api/favoritePost', payload)
      .then((res) => {
        context.commit('UPDATE_NEWS_POST_FAVORITE', res.data);
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },

  // Nested replies
  appendNewsNestedReplyTop(context, payload) {
    context.commit('APPEND_NEWS_NESTED_REPLY_TOP', payload);
  },
  loadNestedNewsReplies(context, payload) {
    return this.dispatch('api/getPostReplies', {
      postId: payload.replyId,
      params: payload.params,
    })
      .then((res) => {
        context.commit('SET_NESTED_NEWS_REPLIES', {
          replies: res.data,
          postId: payload.postId,
          replyId: payload.replyId,
        });
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },
  loadNextNestedNewsReplies(context, payload) {
    return this.dispatch('api/getPostReplies', {
      postId: payload.replyId,
      params: payload.params,
    })
      .then((res) => {
        context.commit('APPEND_NESTED_NEWS_REPLY_BOTTOM', {
          replies: res.data,
          postId: payload.postId,
          replyId: payload.replyId,
        });
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },
  likeNestedNewsReply(context, payload) {
    context.commit('UPDATE_NEWS_NESTED_REPLY_LIKE_OPTIMISTIC', payload);
    return this.dispatch('api/likePost', payload.nestedReplyId)
      .then((res) => {
        context.commit('UPDATE_NESTED_NEWS_REPLY', {
          data: res.data,
          postId: payload.postId,
        });
      })
      .catch((err) => {
        context.commit('ROLLBACK_NEWS_NESTED_REPLY_LIKE', payload);
        context.commit('SET_NEWS_REPLIES_ERROR', {
          err: err,
          postId: payload.replyId,
        });
      });
  },
  favoriteNestedNewsReply(context, payload) {
    return this.dispatch('api/favoritePost', payload.nestedReplyId)
      .then((res) => {
        context.commit('UPDATE_NESTED_NEWS_REPLY', {
          data: res.data,
          postId: payload.postId,
        });
      })
      .catch((err) => {
        context.commit('SET_NEWS_FEED_ERROR', err);
      });
  },
  deleteNewsPostReply(context, payload) {
    return this.dispatch('api/deleteUserPost', { postId: payload.replyId })
      .then((res) => {
        context.commit('DELETE_NEWS_POST_REPLY_SUCCESS', {
          postId: payload.postId,
          replyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  deleteNewsPostNestedReply(context, payload) {
    return this.dispatch('api/deleteUserPost', {
      postId: payload.nestedReplyId,
    })
      .then((res) => {
        context.commit('DELETE_NEWS_POST_NESTED_REPLY_SUCCESS', {
          postId: payload.postId,
          replyId: payload.replyId,
          nestedReplyId: res.data,
        });
        showToast(window.$nuxt.$t('post_deletion_successful'));
      })
      .catch((err) => {
        context.commit('DELETE_POST_REPLY_ERROR', err);
        showErrorToast(window.$nuxt.$t('error_occured_message'));
      });
  },
  updateNewsReply(context, payload) {
    return this.dispatch('api/updatePost', payload.data)
      .then((res) => {
        showToast(window.$nuxt.$t('post_updated_ok'));
        res.data.updatedDate = payload.data.updatedDate;
        context.commit('UPDATE_NEWS_REPLY_AFTER_EDIT', {
          postId: payload.postId,
          data: res.data,
        });
      })
      .catch((err) => {
        showErrorToast(window.$nuxt.$t('error_occured_message'));
        context.commit('SET_NEWS_REPLIES_ERROR', {
          err: err,
          postId: payload.target,
        });
      });
  },
};
